<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';

  defineProps<{
    validityDate: Date | null;
  }>();

  const formatDisplayDate = (date: Date | null) => {
    if (!date || Number.isNaN(date.getTime())) return 'Selecione uma data';
    return date.toLocaleDateString('pt-BR');
  };

  const emit = defineEmits<{
    (e: 'update:validity-date'): void;
  }>();
</script>

<template>
  <div class="flex flex-col gap-3 p-6">
    <label class="text-sm font-semibold text-gray-07">Selecione a data de vencimento:</label>
    <button
      type="button"
      class="flex items-center gap-2 w-fit px-4 py-2 border border-gray-02 rounded-lg text-gray-07 focus:outline-none focus:border-gray-07 bg-white-01"
      @click="emit('update:validity-date')"
    >
      <IconImage
        :src="CalendarIcon"
        alt="Calendar"
      />
      <span class="text-left text-sm">{{ formatDisplayDate(validityDate ?? null) }}</span>
    </button>
  </div>
</template>
